import { createAction, props } from '@ngrx/store'
import { ApplicationError } from 'src/app/error/model/error'
import { TrackingData, TrackingDetailsData, TrackingViewsData } from '../tracking.model'
import { ProgramEvents } from 'src/app/program-events/model/program-events.model'
import { SelectedUserPreferences } from 'src/app/core/model/reinsurer.model'

export const fetchTracking = createAction('[Tracking] Fetch')

export const fetchTrackingSuccess = createAction(
  '[Tracking] Fetch Success',
  props<{
    trackingData: TrackingData[]
    selectedYear: string
  }>(),
)

export const fetchTrackingFailure = createAction(
  '[Tracking] Fetch Failure',
  props<{ error: ApplicationError }>(),
)

export const filtersChanged = createAction(
  '[Tracking] Filters changed',
  props<{ filters?: Record<string, string[]> }>(),
)

export const filtersChangedMyView = createAction(
  '[Tracking] Filters changed my view',
  props<{ filters?: Record<string, string[]> }>(),
)
export const filtersChangedTeamView = createAction(
  '[Tracking] Filters changed team view',
  props<{ filters?: Record<string, string[]> }>(),
)

export const inceptionDateChanged = createAction(
  '[Tracking] Inception Date changed',
  props<{ minInceptionDate: string; maxInceptionDate: string }>(),
)

export const fetchTrackingDetails = createAction(
  '[Tracking Details] Fetch',
  props<{ programId: number }>(),
)

export const fetchTrackingDetailsSuccess = createAction(
  '[Tracking Details] Fetch Success',
  props<{ trackingDetailsData: TrackingDetailsData[] }>(),
)

export const fetchTrackingDetailsFailure = createAction(
  '[Tracking Details] Fetch Failure',
  props<{ error: ApplicationError }>(),
)

export const updateCompleteProgram = createAction(
  '[Tracking Details] Update Complete',
  props<{ programId: number }>(),
)

export const updateCompleteProgramSuccess = createAction(
  '[Tracking Details] Update Complete Success',
  props<{ programEvents: ProgramEvents }>(),
)

export const updateCompleteProgramFailure = createAction(
  '[Tracking Details] Update Complete Failure',
  props<{ error: ApplicationError }>(),
)

export const saveTrackingPreferences = createAction(
  '[Tracking Details] Save Tracking Preferences',
  props<{ label: string; filters?: Record<string, string[]> }>(),
)

export const saveTrackingPreferencesFailure = createAction(
  '[Tracking Details] Save Tracking Preferences Failure',
  props<{ error: ApplicationError }>(),
)

export const saveTrackingPreferencesSuccess = createAction(
  '[Tracking Details] Save Tracking Preferences Success',
  props<{ userPreferences: SelectedUserPreferences }>(),
)

export const getTrackingPreferences = createAction('[Tracking Details] Get Tracking Preferences')

export const getTrackingPreferencesFailure = createAction(
  '[Tracking Details] Get Tracking Preferences Failure',
  props<{ error: ApplicationError }>(),
)

export const getTrackingPreferencesSuccess = createAction(
  '[Tracking Details] Get Tracking Preferences Success',
  props<{ userPreferences: SelectedUserPreferences[]; selectedPreferenceId?: number }>(),
)

export const setSelectedUserPreferences = createAction(
  '[Tracking Details] Set Selected User Preferences',
  props<{ id: number }>(),
)

export const deleteUserPreference = createAction(
  '[Tracking] Delete User Preference',
  props<{ deletedPreferences: SelectedUserPreferences }>(),
)

export const deleteUserPreferenceSuccess = createAction(
  '[Tracking] Delete User Preference Success',
  props<{ deletedPreferences: SelectedUserPreferences }>(),
)

export const deleteUserPreferenceFailure = createAction(
  '[Tracking] Delete User Preference Failure',
  props<{ error: any }>(),
)

export const updateUserPreference = createAction(
  '[Tracking] Update User Preference',
  props<{ updatedPreferences: any }>(),
)

export const updateUserPreferenceSuccess = createAction(
  '[Tracking] Update User Preference Success',
  props<{ updatedPreferences: any }>(),
)

export const updateUserPreferenceFailure = createAction(
  '[Tracking] Update User Preference Failure',
  props<{ error: any }>(),
)

export const fetchMyViewTracking = createAction(
  '[Tracking] Fetch My View Tracking',
  props<{ applyDefaultYear?: boolean }>(),
)

export const fetchMyViewTrackingSuccess = createAction(
  '[Tracking] Fetch My View Tracking Success',
  props<{
    trackingMyViewsData: TrackingViewsData[]
    selectedYear?: string
  }>(),
)

export const fetchMyViewTrackingFailure = createAction(
  '[Tracking] Fetch My View Tracking  Failure',
  props<{ error: ApplicationError }>(),
)

export const fetchTeamViewTracking = createAction(
  '[Tracking] Fetch Team View Tracking',
  props<{ applyDefaultYear?: boolean }>(),
)

export const fetchTeamViewTrackingSuccess = createAction(
  '[Tracking] Fetch Team View Tracking Success',
  props<{
    trackingTeamViewsData: TrackingViewsData[]
    selectedYear?: string
  }>(),
)

export const fetchTeamViewTrackingFailure = createAction(
  '[Tracking] Fetch Team View Tracking  Failure',
  props<{ error: ApplicationError }>(),
)

export const refreshViews = createAction('[Tracking] Refresh Views')

export const fetchClientViewTracking = createAction('[Tracking] Fetch Client View Tracking')

export const fetchClientViewTrackingSuccess = createAction(
  '[Tracking] Fetch Client View Tracking Success',
  props<{ trackingClientViewsData: TrackingViewsData[] }>(),
)

export const fetchClientViewTrackingFailure = createAction(
  '[Tracking] Fetch Client View Tracking  Failure',
  props<{ error: ApplicationError }>(),
)

export const updateColumnValue = createAction(
  '[Tracking] Update Column Value',
  props<{
    opportunityId: number
    category: string
    newValue: string
    date?: string
    viewType: string
  }>(),
)

export const updateColumnValueSuccess = createAction(
  '[Tracking] Update Column Value Success',
  props<{
    opportunityId: string
    category: string
    newValue: string
    dateTime: string
    viewType: string
  }>(),
)

export const updateColumnValueFailure = createAction(
  '[Tracking] Update Column Value Failure',
  props<{ error: ApplicationError }>(),
)

export const updateUserValue = createAction(
  '[Tracking] Update User Value',
  props<{
    opportunityId: number
    role: string
    email_ids: string[]
    viewType: string
  }>(),
)

export const updateUserValueSuccess = createAction(
  '[Tracking] Update User Value Success',
  props<{
    opportunityId: string
    role: string
    email_ids: string[]
    viewType: string
  }>(),
)

export const updateUserValueFailure = createAction(
  '[Tracking] Update User Value Failure',
  props<{ error: ApplicationError }>(),
)

export const updateComment = createAction(
  '[Tracking] Update Comment',
  props<{
    opportunityId: number
    category: string
    comment: string
    viewType: string
  }>(),
)

export const updateCommentSuccess = createAction(
  '[Tracking] Update Comment Success',
  props<{
    opportunityId: string
    category: string
    comment: string
    viewType: string
  }>(),
)

export const updateCommentFailure = createAction(
  '[Tracking] Update Comment Failure',
  props<{ error: ApplicationError }>(),
)
